import { SvgIcon, type SvgIconProps } from './svgIcon'

export function ProgressActivityIcon({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 20 20" {...props}>
      <path
        d="M9.99693 19.5C8.69639 19.5 7.4687 19.2508 6.31385 18.7525C5.159 18.2541 4.15048 17.5739 3.28828 16.7117C2.42609 15.8495 1.74583 14.841 1.2475 13.6861C0.749167 12.5313 0.5 11.3036 0.5 10.003C0.5 8.68663 0.749683 7.45349 1.24905 6.30363C1.7484 5.15378 2.4282 4.14872 3.28845 3.28845C4.14872 2.4282 5.15742 1.7484 6.31455 1.24905C7.4717 0.749684 8.70018 0.5 9.99998 0.5V1.99998C7.78331 1.99998 5.89581 2.77914 4.33748 4.33748C2.77914 5.89581 1.99998 7.78331 1.99998 9.99998C1.99998 12.2166 2.77914 14.1041 4.33748 15.6625C5.89581 17.2208 7.78331 18 9.99998 18C12.2166 18 14.1041 17.2208 15.6625 15.6625C17.2208 14.1041 18 12.2166 18 9.99998H19.5C19.5 11.2998 19.2503 12.5283 18.7509 13.6854C18.2516 14.8425 17.5718 15.8512 16.7115 16.7115C15.8512 17.5718 14.8462 18.2516 13.6963 18.7509C12.5465 19.2503 11.3133 19.5 9.99693 19.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
